import styled, { css } from "styled-components";

export const LabelsContainer = styled.div`
  position: absolute;
  z-index: 30;

  ${({ size, top, left }) => css`
    width: ${`${size.width}px`};
    top: ${`${top}px`};
    left: ${`${left}px`};
  `};
`;

export const PrimaryText = styled.p`
  color: ${(props) => props.color};
  ${({ size }) => size.primary};
  font-weight: 800;
  font-family: "PoppinsClone", "Poppins", sans-serif !important;
  text-transform: uppercase;
  user-select: none;
  width: fit-content;
  max-width: 100%;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: normal;
`;

export const SecondaryText = styled.p`
  word-wrap: break-word;
  font-weight: 500;
  font-family: "PoppinsClone", "Poppins", sans-serif !important;
  color: ${(props) => props.color};
  /* transition: all 0.5s ease-in-out; */
  user-select: none;

  ${({ size }) => size.secondary};
`;
export const CallText = styled.div`
  font-weight: 800;
  font-family: "PoppinsClone", "Poppins", sans-serif !important;
  background-color: ${(props) => props.background};
  color: ${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  /* transition: all 0.5s ease-in-out; */
  text-transform: uppercase;
  user-select: none;
  word-wrap: break-word;

  ${({ size }) => size.call};
`;
